module.exports = "/assets/90f60f74185ddb78143f112e382d9c68.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/VI.png
// module id = 1927
// module chunks = 0